import mixpanel, {Dict} from 'mixpanel-browser';

// @ts-ignore
const token = window.state?.mixpanelToken ?? ''
mixpanel.init(token);

let actions = {
    identify: (id: string) => {
        mixpanel.identify(id);
    },
    track: (name: string, props?: Dict) => {
        mixpanel.track(name, props);
    },
};

export let Mixpanel = actions;